import React from 'react'
import Helmet from 'react-helmet'
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {reactI18nextModule} from 'react-i18next'
import '../css/main.scss'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'en',
    ns: 'translations',
    defaultNS: 'translations',
    debug: process.env.NODE_ENV !== 'production',
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true
    }
  })

export default ({children}) => (
  <div>
    <Helmet
      title="Babels Corporate Web Site"
      link={[
        {href: 'https://fonts.googleapis.com/css?family=Montserrat:500,600,800', rel: 'stylesheet'},
        {href: 'https://fonts.googleapis.com/css?family=Vollkorn:600,700', rel: 'stylesheet'},
        {href: 'https://fonts.googleapis.com/css?family=Merriweather+Sans:300,400', rel: 'stylesheet'},
        {href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css', rel: 'stylesheet'}
      ]}
      meta={[
        {name: 'author', content: 'Babels'},
        {name: 'theme-color', content: '#000'}
      ]}
    />
    {children()}
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/index.js